<template>
  <div  id="sections">
    <div class="row-fluid">
      <ul class="nav nav-pills" role="tablist">
        <li class="nav-item">
          <router-link v-slot="{ isExactActive, href, navigate }" to="/me" custom>
            <a id="teams-pill" role="tab" class="nav-link" :class="{ active: isExactActive }"
               :href="href" aria-controls="teams" :aria-selected="isExactActive"
               @click="navigate"
            >
              <i class="fas fa-users fa-fw"></i>My Teams
            </a>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link v-slot="{ isActive, href, navigate }" to="/me/billing" custom>
            <a id="billing-pill" role="tab" class="nav-link" :class="{ active: isActive }"
               :href="href" aria-controls="billing" :aria-selected="isActive"
               @click="navigate"
            >
              <i class="fas fa-credit-card fa-fw"></i>Billing
            </a>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link v-slot="{ isActive, href, navigate }" to="/me/settings" custom>
            <a id="settings-pill" role="tab" class="nav-link" :class="{ active: isActive }"
               :href="href" aria-controls="settings" :aria-selected="isActive"
               @click="navigate"
            >
              <i class="fas fa-cogs fa-fw"></i>Settings
            </a>
          </router-link>
        </li>
      </ul>
    </div>
    <div class="row-fluid mt-5">
      <ul class="nav nav-pills">
        <li class="nav-item">
          <a class="nav-link btn btn-outline-info text-left"
             href="https://help.ganttproject.biz/t/ganttproject-cloud-docs/1954"
             target="_blank">
            <i class="fas fa-rocket fa-fw"></i>Getting Started
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts">
import {Component, Vue} from 'vue-facing-decorator';

@Component
export default class DashboardMenu extends Vue {}
</script>
